import {
  mapState,
  mapActions,
  mapGetters
} from 'vuex'

export default {
  data () {
    return {
      isLoaded: false,
      yearStep: 1,
      priceStep: 5000
    }
  },
  computed: {
    ...mapState({
      brands: state => state.inventoryVautoFilter.filterData.brands,
      models: state => state.inventoryVautoFilter.filterData.models,
      trims: state => state.inventoryVautoFilter.filterData.trims,
      bodies: state => state.inventoryVautoFilter.filterData.bodies,
      customization: state => state.common.customization
    }),
    ...mapGetters({
      filterModel: 'inventoryVautoFilter/getFilter',
      yearRange: 'inventoryVautoFilter/getYearsRange',
      yearLimit: 'inventoryVautoFilter/getYearsLimit',
      priceRange: 'inventoryVautoFilter/getPriceRange',
      priceLimit: 'inventoryVautoFilter/getPriceLimit',
      price: 'inventoryVautoFilter/getPriceValues',
      years: 'inventoryVautoFilter/getYearValues'
    }),
    borderStyle: function () {
      var borderStyle = this.customization.borderOn ? 'solid 1px ' + this.customization.borderColor : 'none'
      var backgroundStyle = this.customization.mainColor
      var colorStyle = this.customization.fontColor
      return {
        border: borderStyle,
        background: backgroundStyle,
        color: colorStyle
      }
    }
  },
  methods: {
    ...mapActions({
      loadFilterData: 'inventoryVautoFilter/getFilterData',
      updateFilter: 'inventoryVautoFilter/updateFilter'
    }),
    // async initPriceRanges () {
    //   if (this.filterModel.priceFrom && this.filterModel.priceTo) {
    //     return
    //   }
    //   this.filterModel.priceFrom = this.priceLimit.from
    //   this.filterModel.priceTo = this.priceLimit.to
    //   await this.updateFilter(this.filterModel)
    // },
    // async initYearsRanges () {
    //   if (this.filterModel.yearFrom && this.filterModel.yearTo) {
    //     return
    //   }
    //   this.filterModel.yearFrom = this.yearLimit.from
    //   this.filterModel.yearTo = this.yearLimit.to
    //   await this.updateFilter(this.filterModel)
    // },
    async onBrandChange () {
      await this.updateFilter(this.filterModel)
      this.isLoaded = false
      await this.loadFilterData(this.filterModel)
      this.isLoaded = true
    },
    async onModelChange () {
      await this.updateFilter(this.filterModel)
      this.isLoaded = false
      await this.loadFilterData(this.filterModel)
      this.isLoaded = true
    },
    async onTrimChange () {
      await this.updateFilter(this.filterModel)
      this.isLoaded = false
      await this.loadFilterData(this.filterModel)
      this.isLoaded = true
    },
    async onBodyChange () {
      await this.updateFilter(this.filterModel)
      this.isLoaded = false
      await this.loadFilterData(this.filterModel)
      this.isLoaded = true
    },
    async onPriceChanged (data) {
      if (this.price.from === data.from && this.price.to === data.to) {
        return
      }
      // do not allow to set same prices for priceFrom and priceTo to prevent api result error
      this.validatePrice(data)

      this.filterModel.priceFrom = this.price.from
      this.filterModel.priceTo = this.price.to

      await this.updateFilter(this.filterModel)
      this.isLoaded = false
      await this.loadFilterData(this.filterModel)
      this.isLoaded = true
    },
    validatePrice (data) {
      if (this.price.from === data.from && data.to === data.from) {
        this.price.to = data.to + this.priceStep
      } else {
        this.price.to = data.to
      }
      if (this.price.to === data.to && data.from === data.to) {
        this.price.from = data.from - this.priceStep
      } else {
        this.price.from = data.from
      }
    },
    async onYearsChanged (data) {
      if ((Math.round(this.years.from / this.yearStep) * this.yearStep) === data.from && (Math.round(this.years.to / this.yearStep) * this.yearStep) === data.to) {
        return
      }
      this.isLoaded = false
      this.filterModel.yearFrom = data.from
      this.filterModel.yearTo = data.to
      await this.updateFilter(this.filterModel)
      await this.loadFilterData(this.filterModel)
      this.isLoaded = true
    },
    async resetFilterModel () {
      this.filterModel.modelId = null
      this.filterModel.brandId = null
      this.filterModel.trans = null
      this.filterModel.color = null
      this.filterModel.body = null
      this.filterModel.yearFrom = null
      this.filterModel.yearTo = null
      this.filterModel.priceFrom = null
      this.filterModel.priceTo = null
      this.filterModel.trim = null
      this.filterModel.page = 1
      this.filterModel.perPage = 12
      await this.updateFilter(this.filterModel)
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/src/mixins/vauto.filter.mixin.js